import { Edit, Remove } from "@app/components/Actions";
import pathRoutes from "../../../../routes/pathRoutes";
import { useMasterTables } from "../useMasterTables";
import { PermissionComponentGate } from "@app/utils/PermissionComponentGate";
import { RolesTypes } from "@app/pages/users/utils/helpers";

export const columnsEquipos = (keysTables: string[], tableName: string) => [
  {
    field: "id",
    headerName: "id",
    headerAlign: "center",
    align: "left",
    flex: 0,
  },
  {
    field: "codigo",
    headerName: "Codigo",
    headerAlign: "center",
    align: "left",
    flex: 1,
  },
  {
    field: "descripcion",
    headerName: "Descripción",
    headerAlign: "center",
    align: "left",
    flex: 1,
  },
  {
    field: "codet",
    headerName: "Código viejo",
    headerAlign: "center",
    align: "left",
    flex: 1,
  },
  {
    field: "codigoviejo",
    headerName: "Detector",
    headerAlign: "center",
    align: "left",
    flex: 1,
  },
  {
    field: "mide",
    headerName: "Mide",
    headerAlign: "center",
    align: "left",
    flex: 1,
  },
  {
    field: "height",
    headerName: "Altura",
    headerAlign: "center",
    align: "left",
    flex: 1,
  },
  {
    field: "factor",
    headerName: "Factor",
    headerAlign: "center",
    align: "left",
    flex: 1,
  },
  {
    field: "is_geometry",
    headerName: "Es geometría",
    headerAlign: "center",
    align: "left",
    flex: 1,
    renderCell: (params: any) => (
      <div>{`${params.row.is_geometry ? "Sí" : "No"}`}</div>
    ),
  },
  {
    field: "actions",
    headerName: "Acciones",
    headerAlign: "center",
    align: "left",
    flex: 1,
    renderCell: (params: any) => (
      <>
        <PermissionComponentGate
          permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}
        >
          <Edit
            to={`${pathRoutes.ADMIN_MASTER_TABLES}/editar/${tableName}/${params.id}`}
          />
          <Remove
            onRemove={() =>
              useMasterTables.getState().deleteData(params.id, tableName)
            }
            title="Va a borrar de forma permanente este registro"
            text="¿Quiere continuar?"
          />
        </PermissionComponentGate>
      </>
    ),
  },
];
